/* Mirror actual Cookiebot choices through Shopify's public Customer Privacy API. */
(() => {
  let pending = null;
  let lastApplied = '';
  let inFlight = false;
  let loading = false;
  let retries = 0;

  function apply() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!pending || inFlight || !privacy?.setTrackingConsent) return;
    const value = pending;
    const signature = JSON.stringify(value);
    if (signature === lastApplied) return;
    inFlight = true;
    try {
      privacy.setTrackingConsent(value, (result) => {
        inFlight = false;
        if (result?.error) return;
        lastApplied = signature;
        apply();
      });
    } catch (_) { inFlight = false; }
  }

  function loadPrivacy() {
    if (window.Shopify?.customerPrivacy) { apply(); return; }
    if (loading) return;
    if (!window.Shopify?.loadFeatures) {
      if (++retries <= 40) window.setTimeout(loadPrivacy, 250);
      return;
    }
    loading = true;
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      loading = false;
      if (!error) apply();
    });
  }

  function sync(event) {
    const cookie = window.Cookiebot;
    // No fabricated choice before the visitor has responded. A decline also covers withdrawal.
    if (!cookie?.consent || (!cookie.hasResponse && event?.type !== 'CookiebotOnDecline')) return;
    if (cookie.consent.preferences === false || event?.type === 'CookiebotOnDecline') {
      try { window.localStorage.removeItem('Concept:recently-viewed'); } catch (_) {}
      try { window.LeslisRecentlyViewed?.clear(); } catch (_) {}
    }
    pending = {
      analytics: cookie.consent.statistics === true,
      marketing: cookie.consent.marketing === true,
      preferences: cookie.consent.preferences === true
    };
    // Sale-of-data opt-outs/GPC are independent; do not overwrite them with marketing consent.
    loadPrivacy();
  }

  ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'].forEach((name) => {
    window.addEventListener(name, sync);
  });
  sync();
})();
